<template>
<div class="relative">
  <div class="vx-navbar-wrapper navbar-full p-0">
    <vs-navbar class="navbar-custom navbar-skelton">
      <router-link tag="div" to="/" class="vx-logo cursor-pointer mr-auto flex items-center">
        <logo class="mr-4 fill-current text-primary" />
        <logoCmu class="fill-current text-primary" />
      </router-link>

      <vs-spacer />

      <div class="w-full flex-grow md:flex md:items-center md:w-auto hidden">
        <div class="text-xl sm:flex-grow">
          <ul class="sm:flex justify-around mt-8 w-full md:mt-0 md:ml-auto md:w-3/4">
            <li class="p-2 truncate">
              <router-link tag="a" to="/dust/map" class="router-link-exact-active router-link-active" title="แผนที่คุณภาพอากาศ">
              แผนที่คุณภาพอากาศ
              </router-link>
            </li>
            <li class="p-2 truncate">
              <router-link tag="a" to="/dust/report/511300001" class="router-link-exact-active router-link-active" title="รายงานสถานการณ์และคุณภาพอากาศ">
                รายงานสถานการณ์และคุณภาพอากาศ
              </router-link>
            </li>
            <li v-if="!activeUserInfo.displayName" class="p-2 truncate">
              <router-link tag="a" to="/pages/login" class="router-link-exact-active router-link-active" title="เข้าสู่ระบบ">
                เข้าสู่ระบบ
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <profile-drop-down/>
    </vs-navbar>
  </div>
</div>
</template>

<script>
import Bookmarks            from './components/Bookmarks.vue'
import I18n                 from './components/I18n.vue'
import SearchBar            from './components/SearchBar.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'
import Logo                 from '../Logo.vue'
import LogoCmu              from '../LogoCmu.vue'

export default {
  name: 'the-navbar-horizontal',
  props: {
    logo: { type: String                                                                                                          },
    navbarType: {
      type: String,
      required: true
    },
    logoCmu: { type: String }
  },
  components: {
    Logo,
    LogoCmu,
    Bookmarks,
    I18n,
    SearchBar,
    ProfileDropDown
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    navbarColor () {
      let color = '#7367F0'
      if (this.navbarType === 'sticky') color = '#f7f7f7'
      else if (this.navbarType === 'static') {
        if (this.scrollY < 50) {
          color = '#f7f7f7'
        }
      }

      if (this.isThemedark === 'dark') {
        if (color === '#fff') {
          color = '#10163a'
        } else {
          color = '#262c49'
        }
      }

      return color
    },
    isThemedark ()          { return this.$store.state.theme                                                                       },
    scrollY ()              { return this.$store.state.scrollY                                                                     },
    verticalNavMenuWidth () { return this.$store.state.verticalNavMenuWidth                                                        },
    windowWidth ()          { return this.$store.state.windowWidth                                                                 }
  }
}

</script>

